<template>
  <multiselect
    :value="value"
    :options="options"
    :searchable="true"
    track-by="value"
    label="name"
    :close-on-select="true"
    :show-labels="false"
    :placeholder="placeholder"
    class="field-input__inner form__input select-template"
    @select="onSelect"
    @close="$emit('close')"
  >
    <span slot="noResult">Ничего не найдено</span>
  </multiselect>
</template>
<script>
import Multiselect from 'vue-multiselect';

export default {
  name: 'SelectTemplate',
  components: {
    Multiselect,
  },
  props: {
    placeholder: {
      type: String,
      default: '',
    },
    value: {
      type: [Object, String],
      default: null,
    },
    options: {
      type: Array,
      required: true,
    },
  },
  methods: {
    onSelect(e) {
      this.$emit('input', e);
    },
  },
};
</script>
<style lang="scss">
.select-template {
  .multiselect__placeholder {
    color: #9fb3c3;
  }
}
</style>
